import { z } from 'zod';

import type { TFunction } from 'i18next';

import { requiredSelect } from './common';

// Editing never moves a span — the range fields are not even rendered — so the window is
// only asked for on create.
const staffSpanFields = (t: TFunction, isEditMode: boolean) => ({
  staff_id: isEditMode ? z.string().nullable() : requiredSelect(t),
  start_minute: isEditMode ? z.string().nullable() : requiredSelect(t),
  end_minute: isEditMode ? z.string().nullable() : requiredSelect(t),
});

const isWindowOrdered = (values: {
  start_minute: string | null;
  end_minute: string | null;
}) => Number(values.end_minute) > Number(values.start_minute);

export const createBookingStaffBlockSchema = (
  t: TFunction,
  isEditMode = false,
) =>
  z
    .object({
      ...staffSpanFields(t, isEditMode),
      comment: z.string(),
    })
    .refine((values) => isEditMode || isWindowOrdered(values), {
      path: ['end_minute'],
      message: t('validation_invalid_date'),
    });

export const createBookingStaffAnnotationSchema = (
  t: TFunction,
  isEditMode = false,
) =>
  z
    .object({
      ...staffSpanFields(t, isEditMode),
      text: z.string().min(1, { message: t('validation_required') }),
    })
    .refine((values) => isEditMode || isWindowOrdered(values), {
      path: ['end_minute'],
      message: t('validation_invalid_date'),
    });

export type BookingStaffBlockFormValues = z.infer<
  ReturnType<typeof createBookingStaffBlockSchema>
>;

export type BookingStaffAnnotationFormValues = z.infer<
  ReturnType<typeof createBookingStaffAnnotationSchema>
>;
